/**
 * Our Story animation - progressive enhancement
 * - Default content is visible
 * - JS adds .is-anim-enabled then reveals blocks with .is-visible
 * - Re-inits on Shopify theme editor section reload
 */
(function () {
  function initOurStory(root) {
    const sectionEl = root && root.matches && root.matches('.our-story')
      ? root
      : (root ? root.querySelector('.our-story') : document.querySelector('.our-story'));

    if (!sectionEl) return;

    const blocks = sectionEl.querySelectorAll('.js-our-story-anim');
    if (!blocks.length) return;

    // Respect reduced motion
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // If no animation desired or IntersectionObserver missing, just show all
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      sectionEl.classList.remove('is-anim-enabled');
      blocks.forEach(b => b.classList.add('is-visible'));
      return;
    }

    // Enable animation mode ONLY after JS is running
    sectionEl.classList.add('is-anim-enabled');

    // Reset visibility before observing (important after theme editor re-renders)
    blocks.forEach(b => b.classList.remove('is-visible'));

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    blocks.forEach(b => observer.observe(b));
  }

  // Normal page load
  document.addEventListener('DOMContentLoaded', () => initOurStory(document));

  // Shopify Theme Editor: section reloaded/updated
  document.addEventListener('shopify:section:load', (event) => {
    initOurStory(event.target);
  });

  // Also handle blocks being selected/deselected sometimes
  document.addEventListener('shopify:section:select', (event) => {
    initOurStory(event.target);
  });
})();